import { render } from "./FloatActionButton.vue?vue&type=template&id=27102f6c&scoped=true"
import script from "./FloatActionButton.vue?vue&type=script&lang=js"
export * from "./FloatActionButton.vue?vue&type=script&lang=js"

import "./FloatActionButton.vue?vue&type=style&index=0&id=27102f6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27102f6c"]])

export default __exports__
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageSticky,QBtn,QTooltip});
